import React from 'react';
import { Link, useLocation } from 'react-router-dom';
export const Navbar = () => {
  const location = useLocation();
  const isAgent = location.pathname.startsWith('/agent');
  const isAdmin = location.pathname.startsWith('/admin');
  const links = isAdmin ? [{
    to: '/admin',
    label: 'Control room'
  }, {
    to: '/',
    label: 'Guest site'
  }] : isAgent ? [{
    to: '/agent',
    label: 'Bookings'
  }, {
    to: '/agent/new-booking',
    label: 'New stay'
  }] : [{
    to: '/',
    label: 'Collection'
  }, {
    to: '/agent/login',
    label: 'Agent desk'
  }, {
    to: '/admin',
    label: 'Control room'
  }];
  return <header className="sticky top-0 z-50 border-b border-white/10 bg-nordvik-ink/90 backdrop-blur-md" data-id="element-40" data-mp="9kksh3z472jk">
      <div className="mx-auto flex h-20 max-w-[1440px] items-center justify-between px-5 sm:px-8 lg:px-12" data-id="element-41" data-mp="1py1kzs5xrm71">
        <Link to="/" className="nv-focus flex items-center gap-3 rounded-sm" data-id="element-42" data-mp="1l09hs1zucdnj">
          <span className="grid h-8 w-8 place-items-center border border-nordvik-orange bg-nordvik-orange text-xs font-black text-white nv-glow" data-id="element-43" data-mp="9opypi81ux4t">LV</span>
          <span className="leading-none" data-id="element-44" data-mp="elzleq420uoy">
            <span className="block text-lg font-black tracking-tight text-white" data-id="element-45" data-mp="jmnj1umsg9s5">LUXE VILLAS</span>
            <span className="mt-1 block text-[9px] uppercase tracking-[0.24em] text-white/45" data-id="element-46" data-mp="olqimzk01nsq">Private stays / 04</span>
          </span>
        </Link>

        <nav aria-label="Primary navigation" className="flex items-center gap-4 sm:gap-7" data-id="element-47" data-mp="3n4xd4ma9q266">
          {links.map(link => {
          const active = location.pathname === link.to;
          return <Link key={link.to} to={link.to} className={`nv-focus rounded-sm pb-1 text-[10px] uppercase tracking-[0.17em] transition-colors sm:text-xs ${active ? 'border-b border-nordvik-orange text-white' : 'text-white/55 hover:text-white'}`} data-id="element-48" data-mp="ukxq5z7c5bk">
                {link.label}
              </Link>;
        })}
        </nav>
      </div>
    </header>;
};